import 'popper.js';
import 'bootstrap';

(function ($, Drupal, drupalSettings) {

  'use strict';

  Drupal.behaviors.biens = {
    attach: function (context) {

    }
  };
  $(document).ready(function () {
    var biens_header = $('.container-with-facets .block--bt-immo-page-title,.container-with-facets .block--bt-immo-content .views-element-container header, .container-with-facets .block--bt-immo-content .bef-exposed-form');
    if(biens_header.length > 0){
      $(biens_header).appendTo('#view-biens-header-container');
    }

    // The slider being synced must be initialized first
    $('.carousel').flexslider({
      animation: "slide",
      controlNav: true,
      animationLoop: false,
      slideshow: false,
      itemWidth: 210,
      itemMargin: 5,
      asNavFor: '.bien__field-image'
    });

    $('.bien__field-image').flexslider({
      animation: "slide",
      controlNav: true,
      animationLoop: false,
      slideshow: false,
      sync: ".carousel"
    });
  });

})(jQuery, Drupal, drupalSettings);

